import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = process.env.REACT_APP_PATIENT_ENCRYPTION_KEY || "";
const ENCRYPTION_PREFIX = "enc:";

export const encryptValue = (value) => {
  if (value === undefined || value === null) return value;
  if (!ENCRYPTION_KEY) return value;
  if (typeof value === "string" && value.startsWith(ENCRYPTION_PREFIX)) {
    return value;
  }

  const payload = JSON.stringify(value);
  const cipher = CryptoJS.AES.encrypt(payload, ENCRYPTION_KEY).toString();
  return `${ENCRYPTION_PREFIX}${cipher}`;
};

export const decryptValue = (value) => {
  if (value === undefined || value === null) return value;
  if (!ENCRYPTION_KEY) return value;
  if (typeof value !== "string") return value;
  if (!value.startsWith(ENCRYPTION_PREFIX)) return value;

  const cipher = value.slice(ENCRYPTION_PREFIX.length);
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, ENCRYPTION_KEY);
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    if (!plaintext) return value;
    return JSON.parse(plaintext);
  } catch (error) {
    return value;
  }
};

const PATIENT_FIELDS = [
  "name",
  "age",
  "gender",
  "phone",
  "email",
  "address",
  "complaint",
  "history",
];

export const encryptPatientPayload = (patient) => {
  const result = { ...patient };
  PATIENT_FIELDS.forEach((field) => {
    if (field in result) {
      result[field] = encryptValue(result[field]);
    }
  });
  return result;
};

export const decryptPatient = (patient) => {
  const result = { ...patient };
  PATIENT_FIELDS.forEach((field) => {
    if (field in result) {
      result[field] = decryptValue(result[field]);
    }
  });
  return result;
};
